import { render, staticRenderFns } from "./race_orderconfirm.vue?vue&type=template&id=0cedea88&scoped=true&"
import script from "./race_orderconfirm.vue?vue&type=script&lang=js&"
export * from "./race_orderconfirm.vue?vue&type=script&lang=js&"
import style0 from "./race_orderconfirm.vue?vue&type=style&index=0&id=0cedea88&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cedea88",
  null
  
)

export default component.exports